export default __webpack_public_path__ + "static/media/sponsor.2e29ef38.png";